/* global google */
import React, { useState, useRef, useCallback, useEffect } from "react";
import { 
  Button, Box
} from "@mui/material";
import {
  withScriptjs,
  withGoogleMap,
  GoogleMap,
  Polygon,
  Marker
} from "react-google-maps";
import GooglePlacesAutocomplete, { geocodeByPlaceId } from 'react-google-places-autocomplete';
import { ClearOutlined, DoneOutlined, RectangleOutlined } from "@mui/icons-material";
// import { DrawingManager } from "react-google-maps/lib/components/drawing/DrawingManager";

function INS_GEOMETRY(props) {
  const {zoom,center} = props;
  const [disabled, setDisabled] = useState(true);
  const [path, setPath] = useState([
    { lat: 52.52549080781086, lng: 13.398118538856465 },
    { lat: 52.48578559055679, lng: 13.36653284549709 },
    { lat: 52.48871246221608, lng: 13.44618372440334 }
  ]);
  const polygonRef = useRef(null);
  const listenersRef = useRef([]);
  const [isDrawing, setIsDrawing] = useState(false);
  const [drawingPath, setDrawingPath] = useState([]);
  useEffect(()=>{
    if(props.geometry.length > 1){
      let polygonQuery = '';
      props.geometry.map((x,index)=>{
        let query = "INSERT [dbo].[INSTALLATIONS_GEOMETRY] ([INSGE_INS_ID], [INSGE_POL_NUMBER], [INSGE_ORDER], [INSGE_LATITUDE], [INSGE_LONGITUDE], [INSGE_INI_APPLY_DATE], [INSGE_END_APPLY_DATE])\n" +
        "VALUES ( "+props.ins_id+", 1, "+(index+1)+", "+x.lat+","+x.lng+","+" CAST(N'3/31/2022 3:13:17 PM' AS DateTime), CAST(N'1/1/2030 12:00:00 AM' AS DateTime));";
        polygonQuery = polygonQuery.concat("\n\n", query)
      })
      props.setGeometryQuery(polygonQuery);
      setDisabled(false);
    }      
  },[])

  const onPolygonComplete = (polygon, destroy = false) => {
    props.removePolygon();
    let coords = getPaths(polygon);
    props.setGeometry(coords);
    props.setCenter(coords[0]);
    let polygonQuery = '';
    coords.map((x,index)=>{
      let query = "INSERT [dbo].[INSTALLATIONS_GEOMETRY] ([INSGE_INS_ID], [INSGE_POL_NUMBER], [INSGE_ORDER], [INSGE_LATITUDE], [INSGE_LONGITUDE], [INSGE_INI_APPLY_DATE], [INSGE_END_APPLY_DATE])\n" +
      "VALUES ( "+props.ins_id+", 1, "+(index+1)+", "+x.lat+","+x.lng+","+" CAST(N'3/31/2022 3:13:17 PM' AS DateTime), CAST(N'1/1/2030 12:00:00 AM' AS DateTime));";
      polygonQuery = polygonQuery.concat("\n\n", query)
    })
    props.setGeometryQuery(polygonQuery);
    setDisabled(false);
    // setPolygon(createPolygon(polygon.getPath()));

    // // Destroys the polygon that has been drawn by the manager.
    if (destroy) {
      polygon.setMap(null);
    }
  };

  const getPaths = (polygon) => {

    var polygonBounds = polygon.getPath();
    var bounds = [];
    for (var i = 0; i < polygonBounds.length; i++) {
      var point = {
        lat: polygonBounds.getAt(i).lat(),
        lng: polygonBounds.getAt(i).lng()
      };
      bounds.push(point);
    }
    return bounds;
  }

  const onEdit = useCallback(() => {
    if (polygonRef.current) {
      const nextPath = polygonRef.current
        .getPath()
        .getArray()
        .map(latLng => {
          return { lat: latLng.lat(), lng: latLng.lng() };
        });
      setPath(nextPath);
    }
  }, [setPath]);

  const onLoad = useCallback(
    polygon => {
      polygonRef.current = polygon;
      const path = polygon.getPath();
      listenersRef.current.push(
        path.addListener("set_at", onEdit),
        path.addListener("insert_at", onEdit),
        path.addListener("remove_at", onEdit)
      );
    },
    [onEdit]
  );

  // Clean up refs
  const onUnmount = useCallback(() => {
    listenersRef.current.forEach(lis => lis.remove());
    polygonRef.current = null;
  }, []);

  // console.log("The path state is", path);
  
  const onMapClick = (e) => {
    if (!isDrawing) return;

    setDrawingPath((prev) => [
      ...prev,
      {
        lat: e.latLng.lat(),
        lng: e.latLng.lng()
      }
    ]);
  };

  const finishPolygon = () => {
    if (drawingPath.length < 3) {
      alert("Polygon requires at least 3 points");
      return;
    }

    const fakePolygon = {
      getPath: () => ({
        length: drawingPath.length,
        getAt: (index) => ({
          lat: () => drawingPath[index].lat,
          lng: () => drawingPath[index].lng
        })
      }),
      setMap: () => {}
    };

    onPolygonComplete(fakePolygon);
    setDrawingPath([]);
    setIsDrawing(false);
  };
  return (
    <>
      <div style={{position: 'absolute', width: '76%', top: '336px'}}>
        <GooglePlacesAutocomplete
            apiKey="AIzaSyDcPvfjCIqeUpGe8_IaI_-5rIZX9qtCUnI"
            selectProps={{
                onChange: (val) => {
                    geocodeByPlaceId(val.value.place_id)
                    .then(results => props.setCenter({
                    lat: results[0].geometry.location.lat(), 
                    lng: results[0].geometry.location.lng()
                    }))
                    .catch(error => console.error(error));
                }
            }}
        />
      </div>
      <div className="row">
        <Box sx={{ position: 'absolute', top: '390px', left: '10%', textAlign: 'center' }}>
          <Button
            variant="contained"
            onClick={() => {
              setDrawingPath([]);
              setIsDrawing(true);
            }}
          >
            <RectangleOutlined/>
          </Button>

          <Button
            sx={{ ml: 2 }}
            variant="contained"
            disabled={drawingPath.length < 3}
            onClick={finishPolygon}
          >
            <DoneOutlined/>
          </Button>

          <Button
            sx={{ ml: 2 }}
            variant="outlined"
            onClick={() => {
              setDrawingPath([]);
              setIsDrawing(false);
            }}
          >
            <ClearOutlined/>
          </Button>
        </Box>      
        <GoogleMap
          defaultZoom={zoom}
          center={center}
          onClick={onMapClick}
          options={{
            draggableCursor: isDrawing ? "crosshair" : null
          }}
        >
          <Marker
            position={center}
          />
          <Polygon
            path={props.geometry}
            key={props.geometry.length === 0 ? "empty" : "polygon"}
            // editable={true}
            options={{
              strokeColor: "#032d6f",
              strokeOpacity: 0.8,
              strokeWeight: 2,
              fillColor: "#032d6f",
              fillOpacity: 0.35
            }}
            // onMouseUp={onEdit}
            //     // Event used when dragging the whole Polygon
            // onDragEnd={onEdit}
            // onLoad={onLoad}
            // onUnmount={onUnmount}
          />
          {drawingPath.length > 0 && (
            <Polygon
              path={drawingPath}
              options={{
                strokeColor: "#808080",
                strokeOpacity: 0.8,
                strokeWeight: 2,
                fillColor: "#808080",
                fillOpacity: 0.2
              }}
            />
          )}
          {/* <DrawingManager
            defaultDrawingMode={google.maps.drawing.OverlayType.POLYGON}
            defaultOptions={{
            //   drawingControl: true,
              drawingControlOptions: {
                position: google.maps.ControlPosition.TOP_CENTER,
                drawingModes: [google.maps.drawing.OverlayType.POLYGON]
              },
            //   polygonOptions: {editable:true}
            }}
            onPolygonComplete={(polygon) => onPolygonComplete(polygon, true)}
          /> */}
        </GoogleMap>
      </div>
      {/* <Box sx={{ display: 'flex', flexDirection: 'row', pt: 2 }}>
          <Button
              color="inherit"
              onClick={()=>props.handleBack()}
              sx={{ mr: 1 }}
              >
              Back
          </Button>
          <Box sx={{ flex: '1 1 auto' }} />
          <Button 
            type="submit" 
            className="btn btn-blue px-3 fit-content" 
            disabled={disabled}
            onClick={()=>props.handleNext()}>
              Next
          </Button>
      </Box> */}
    </>
  );
}

export default withScriptjs(withGoogleMap(INS_GEOMETRY));